<template>
  <div
    :class="[ 'c-input-container', { '-has-error': !!displayValidation }]"
    @input.once="touched = true"
  >
    <div class="group">
      <label
        class="label"
        v-if="label"
      >
        {{ label }}
        <span
          class="required"
          v-if="required"
        >
          *
        </span>
      </label>
      <slot name="label-content" />
    </div>

    <slot />

    <p
      class="validation"
      v-if="displayValidation"
      data-cy="cinput-validation"
    >
      <c-icon
        icon="warning-circle"
        size="15"
        class="icon"
      />
      {{ validation }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    validation: String,
    required: Boolean,
    label: String,
    displayValidation: Boolean
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.c-input-container {
  margin-bottom: 30px;

  &.-has-error {
    margin-bottom: 30px;
    position: relative;
  }

  & > .validation {
    width: 100%;
    display: block;
  }

  & > .group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    & > .label {
      color: $title-color;
      text-transform: uppercase;
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 10px;

      & > .required {
        color: $failure-color;
        margin-left: 2px;
      }
    }
  }

  & > .validation {
    display: flex;
    align-items: center;
    margin-top: 5px;
    color: $failure-color;
    white-space: nowrap;
    font-size: 11px;
    position: absolute;

    & > .icon {
      fill: $failure-color;
      margin-right: 5px;
      flex-shrink: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CInputContainer.vue